import { LOT_TYPE_ICON, useLotTypes } from "@/components/crm/crmShared";

// iter393 — indice « lot lié » sous le trombone (icône type 11 px + n° mono 9 px). Couleurs du type fixées par la spec.
const TYPE_COLOR = [["appartement", "#AFA9EC"], ["parking", "#85B7EB"], ["débarras", "#EF9F27"], ["debarras", "#EF9F27"]];
export const lotTypeColor = (type) => { const t = String(type || "").toLowerCase(); return TYPE_COLOR.find(([k]) => t.includes(k))?.[1] || "#8A8A96"; };
export const linkedLotTitle = (lots) => (lots.length > 1 ? "Liés aux lots " : "Lié au lot ") + lots.map((l) => `${l.numero}${l.type ? ` · ${l.type}` : ""}`).join(", ");

export default function LinkedLotHint({ lots = [], docId }) {
  const lotTypes = useLotTypes();
  const lot = lots[0];
  if (!lot) return null;
  const Icon = LOT_TYPE_ICON[lotTypes.find((t) => t.label === lot.type)?.icon] || LOT_TYPE_ICON.Square;
  const color = lotTypeColor(lot.type);
  return (
    <span className="inline-flex items-center justify-center" style={{ gap: 2, lineHeight: 1, height: 11, color }} data-testid={`doc-lot-hint-${docId}`}>
      <Icon size={11} style={{ display: "block", flexShrink: 0, margin: 0 }} />
      <span style={{ fontSize: 9, lineHeight: 1, fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace" }}>{lot.numero}</span>
      {lots.length > 1 && <span style={{ fontSize: 8, lineHeight: 1, color: "#8A8A96" }}>+{lots.length - 1}</span>}
    </span>
  );
}
